import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Button,
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';

const TablaDesempeno = ({ columnas, lineas, handleOpen, acciones = false }) => {
    const [data, setData] = React.useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 5
    });

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    //abrir modal
    const openModal = (row) => {
        var feedback = row.original.new_comentariosyfeedbackfinal
        handleOpen(feedback)
    }

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                columns={columns}
                data={data}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.primary.dark, 0.1),
                        maxWidth: '1000px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                // enableColumnResizing
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderRowActions={({
                    row
                }) => <div style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.7rem',
                    margin: '5px'
                }}>
                        <Button variant="contained" color="secondary" onClick={() => openModal(row)}>
                            Feedback
                        </Button>
                    </div>} />
        </>
    )
}

export default TablaDesempeno